module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [(_vm.preferences && _vm.preferences.generalData) ? _c('div', {
    staticClass: "uk-padding"
  }, [_c('h1', [_vm._v("Algemene Instellingen")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('label', [_vm._v("Naam")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.generalData.displayName),
      expression: "preferences.generalData.displayName"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Bedrijfsnaam"
    },
    domProps: {
      "value": (_vm.preferences.generalData.displayName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.preferences.generalData, "displayName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('label', [_vm._v("Website Link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.generalData.websiteLink),
      expression: "preferences.generalData.websiteLink"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Website Link"
    },
    domProps: {
      "value": (_vm.preferences.generalData.websiteLink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.preferences.generalData, "websiteLink", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('label', [_vm._v("Signup Link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.generalData.signupPrefix),
      expression: "preferences.generalData.signupPrefix"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Signup Link"
    },
    domProps: {
      "value": (_vm.preferences.generalData.signupPrefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.preferences.generalData, "signupPrefix", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('label', [_vm._v("Contact Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.generalData.contactEmail),
      expression: "preferences.generalData.contactEmail"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Contact Email"
    },
    domProps: {
      "value": (_vm.preferences.generalData.contactEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.preferences.generalData, "contactEmail", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('label', [_vm._v("No Reply Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.generalData.noReplyEmail),
      expression: "preferences.generalData.noReplyEmail"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "No Reply Email"
    },
    domProps: {
      "value": (_vm.preferences.generalData.noReplyEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.preferences.generalData, "noReplyEmail", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('label', [_vm._v("Sendgrid Account Created Template")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.generalData.accountCreatedTemplate),
      expression: "preferences.generalData.accountCreatedTemplate"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Sendgrid Template ID"
    },
    domProps: {
      "value": (_vm.preferences.generalData.accountCreatedTemplate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.preferences.generalData, "accountCreatedTemplate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('label', [_vm._v("Sendgrid Contect Form Template")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferences.generalData.contactedTemplate),
      expression: "preferences.generalData.contactedTemplate"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Sendgrid Template ID"
    },
    domProps: {
      "value": (_vm.preferences.generalData.contactedTemplate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.preferences.generalData, "contactedTemplate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.update
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("Save")]) : _vm._e(), (_vm.loading) ? _c('div', {
    attrs: {
      "uk-spinner": ""
    }
  }) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79749ce0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CORE/pages/Configuration.vue
// module id = 521
// module chunks = 1